import spinnerUrl from "../assets/spinner.svg";
import spinnerWhiteUrl from "../assets/spinner-white.svg";

const imgUrl = {
  white: spinnerWhiteUrl,
  neutralDark: spinnerUrl,
};

const Spinner = ({
  size,
  variant = "neutralDark",
}: {
  size: number;
  variant?: "neutralDark" | "white";
}) => {
  return <img src={imgUrl[variant]} className={`w-${size} h-${size}`} />;
};

export default Spinner;
